interface RuntimeEnv {
  production?: boolean | string;
  adminApiUrl?: string;
  clientApiUrl?: string;
  authAuthority?: string;
  authConfigId?: string;
  authClientId?: string;
  authScope?: string;
  authLogLevel?: number | string;
  userProfileUrl?: string;
  excelExportUrl?: string;
}

const runtimeEnv: RuntimeEnv = (window as Window & { __env?: RuntimeEnv }).__env ?? {};

const parsedLogLevel = Number(runtimeEnv.authLogLevel);
const logLevel = Number.isFinite(parsedLogLevel) && String(runtimeEnv.authLogLevel ?? '').trim() !== '' ? parsedLogLevel : 3;

export const environment = {
  production: String(runtimeEnv.production ?? '') === 'true',
  adminApiUrl: runtimeEnv.adminApiUrl || 'https://dev-admin-api.microbuildprogress.no/',
  clientApiUrl: runtimeEnv.clientApiUrl || 'https://dev-client-api.microbuildprogress.no/',
  userProfileUrl: runtimeEnv.userProfileUrl || 'https://identityserver.devmicrobuild.no/dashboard',
  excelExportUrl: runtimeEnv.excelExportUrl || 'https://dev-jsontoexcel.microbuild.no/',
  authConfig: {
    configId: runtimeEnv.authConfigId || 'mb-progress-dev',
    authority: runtimeEnv.authAuthority || 'https://dev.microbuildauth.no',
    redirectUrl: `${window.location.origin}/auth-callback/`,
    postLogoutRedirectUri: `${window.location.origin}/`,
    clientId: runtimeEnv.authClientId || 'mb-progress-web',
    scope: runtimeEnv.authScope || 'openid progress-admin progress-client offline_access',
    responseType: 'code',
    silentRenew: true,
    renewTimeBeforeTokenExpiresInSeconds: 60,
    autoUserInfo: false,
    renewUserInfoAfterTokenRenew: false,
    useRefreshToken: true,
    triggerAuthorizationResultEvent: true,
    logLevel,
  }
};
